import { createFileRoute } from '@tanstack/react-router'
import { AdminLoyaltyMembers } from '@/components/admin/marketing/AdminLoyaltyMembers'

export const Route = createFileRoute('/admin/marketing/members')({
  component: () => <AdminLoyaltyMembers />,
})
